import styled from "styled-components";
import { Heading } from "rebass/styled-components";

export default styled(Heading)`
  font-size: ${(p) => p.theme.fontSizes[5]};
`;
